import React from 'react';

import { useTheme } from '@/services/theme';
import { FormField } from '@/pages/LandingPage/sections/ContactUs/components/ui/FormField';
import { LabelContainer } from '@/pages/LandingPage/sections/ContactUs/components/ui/LabelContainer';
import { Input } from '@/pages/LandingPage/sections/ContactUs/components/ui/Input';
import { Label } from '@/pages/LandingPage/sections/ContactUs/components/ui/Label';
import { TextArea } from '@/pages/LandingPage/sections/ContactUs/components/ui/TextArea';
import { LabelSuffix } from '@/pages/LandingPage/sections/ContactUs/components/ui/LabelSuffix';
import { ErrorLabel } from '@/pages/LandingPage/sections/ContactUs/components/ui/ErrorLabel';

type ContactFormFieldProps = {
  label: string;
  labelSuffix?: string;
  placeholder?: string;
  isRequired?: boolean;
  type: 'text' | 'email' | 'textarea';
  name: string;
  value: string;
  error?: string;
  onChange: (value: string) => void;
};

export const ContactFormField: React.FC<ContactFormFieldProps> = ({
  label,
  labelSuffix,
  type,
  placeholder,
  isRequired,
  name,
  value,
  onChange,
  error,
}) => {
  const { theme } = useTheme();
  const fieldId = `contact_us_field_${name}`;

  return (
    <FormField>
      <LabelContainer hasSuffix={!!labelSuffix}>
        <Label for={fieldId} theme={theme} isRequired={isRequired}>
          {label}
        </Label>
        {labelSuffix && <LabelSuffix theme={theme}>{labelSuffix}</LabelSuffix>}
      </LabelContainer>
      {(type === 'text' || type === 'email') && (
        <Input
          className={error ? 'error' : ''}
          id={fieldId}
          name={name}
          theme={theme}
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        />
      )}

      {type === 'textarea' && (
        <TextArea
          className={error ? 'error' : ''}
          id={fieldId}
          name={name}
          theme={theme}
          placeholder={placeholder}
          required={isRequired}
          value={value}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
        />
      )}
      {error && <ErrorLabel theme={theme}>{error}</ErrorLabel>}
    </FormField>
  );
};
